import { ICountry } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/useMakerSignUpForm";
import { IOption } from "@faire/web--source/slate/Dropdown";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { IBrandLead } from "@faire/web-api--source/indigofair/data/IBrandLead";

export type MakerSignUpFormStore = {
  _source?: IBrandLead.Source;
  email: string;
  companyName: string;
  url: string;
  categoryOption?: IOption;
  secondaryCategoryOptions: Set<string>;
  country: ICountry | null;
  stockists?: number;
  numProducts?: number;
  formErrors: Record<string, string>;
  apiErrors: Record<string, string>;
  temporaryPosLinkKey: string | undefined;
  brandLeadToken: string | null;
  brandLeadCreationFailure: boolean;
  urlValidationInProgress: boolean;
  canProvideMoreInfo: boolean;
};

const {
  useStore: useMakerSignUpFormContextStore,
  Provider: MakerSignUpFormContextStoreProvider,
} = createContextStore<MakerSignUpFormStore>(
  {
    email: "",
    companyName: "",
    url: "",
    secondaryCategoryOptions: new Set(),
    country: null,
    formErrors: {},
    apiErrors: {},
    urlValidationInProgress: false,
    temporaryPosLinkKey: undefined,
    brandLeadToken: null,
    brandLeadCreationFailure: false,
    canProvideMoreInfo: false,
  },
  {
    name: "MakerSignUpFormStore",
  }
);
export { useMakerSignUpFormContextStore, MakerSignUpFormContextStoreProvider };
